import React from 'react';
import Modal from './Modal';
import { styles } from '../../styles/theme';

const EmailPreview = ({
  isOpen,
  onClose,
  email,
  subject,
  recipient,
  content
}) => {
  // Convert plain text to HTML with line breaks
  const formatContent = (text) => {
    if (!text) return '';
    return text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br>');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Preview do Email" maxWidth="700px">
      <div style={{ marginBottom: '20px' }}>
        <div style={{
          backgroundColor: '#0d1117',
          border: '1px solid #30363d',
          borderRadius: '6px',
          padding: '16px',
          marginBottom: '16px'
        }}>
          <div style={{ marginBottom: '8px' }}>
            <span style={{ color: '#7d8590', fontWeight: '500', marginRight: '8px' }}>De:</span>
            <span style={{ color: '#c9d1d9' }}>Webinar Company &lt;noreply@webinarcompany.com&gt;</span>
          </div>
          <div style={{ marginBottom: '8px' }}>
            <span style={{ color: '#7d8590', fontWeight: '500', marginRight: '8px' }}>Para:</span>
            <span style={{ color: '#c9d1d9' }}>{recipient}</span>
          </div>
          <div>
            <span style={{ color: '#7d8590', fontWeight: '500', marginRight: '8px' }}>Assunto:</span>
            <span style={{ color: '#58a6ff', fontWeight: '600' }}>{subject}</span>
          </div>
        </div>

        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '6px',
          padding: '24px',
          color: '#1a1a1a',
          fontFamily: 'Arial, sans-serif',
          fontSize: '14px',
          lineHeight: '1.6',
          maxHeight: '400px',
          overflow: 'auto'
        }}>
          <div dangerouslySetInnerHTML={{ __html: formatContent(content) }} />
        </div>
      </div>

      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
        <button
          style={{ ...styles.button, ...styles.buttonSecondary }}
          onClick={onClose}
        >
          Fechar
        </button>
      </div>
    </Modal>
  );
};

export default EmailPreview;
